import React from 'react';
import clsx from 'clsx';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

/**
 * KPI Card
 * Props: title, value, unit, icon, trend (number %), color, loading, subtitle
 */
export default function KPICard({ title, value, unit, icon: Icon, trend, color = 'primary', loading, subtitle }) {
  const colors = {
    primary:  'bg-primary-50 text-primary-500',
    green:    'bg-emerald-50 text-emerald-600',
    amber:    'bg-amber-50 text-amber-600',
    red:      'bg-red-50 text-red-600',
    blue:     'bg-blue-50 text-blue-600',
    purple:   'bg-purple-50 text-purple-600',
  };

  const trendColor = trend > 0 ? 'text-accent' : trend < 0 ? 'text-danger' : 'text-gray-400';
  const TrendIcon  = trend > 0 ? TrendingUp : trend < 0 ? TrendingDown : Minus;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">{title}</p>
          {loading ? (
            <div className="h-8 w-24 bg-gray-100 rounded animate-pulse mt-2" />
          ) : (
            <p className="text-2xl font-bold text-gray-900 mt-1">
              {value !== null && value !== undefined ? value : '—'}
              {unit && <span className="text-sm font-normal text-gray-500 ml-1">{unit}</span>}
            </p>
          )}
          {subtitle && <p className="text-xs text-gray-400 mt-1">{subtitle}</p>}
        </div>
        {Icon && (
          <div className={clsx('h-10 w-10 rounded-lg flex items-center justify-center shrink-0 ml-3', colors[color])}>
            <Icon size={20} />
          </div>
        )}
      </div>

      {trend !== undefined && trend !== null && (
        <div className={clsx('flex items-center gap-1 mt-3 text-xs font-medium', trendColor)}>
          <TrendIcon size={13} />
          <span>{Math.abs(trend).toFixed(1)}% vs last month</span>
        </div>
      )}
    </div>
  );
}
